import { render, staticRenderFns } from "./articleOperationBar.vue?vue&type=template&id=1c787cdd&scoped=true&"
import script from "./articleOperationBar.vue?vue&type=script&lang=ts&"
export * from "./articleOperationBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c787cdd",
  null
  
)

export default component.exports